var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.typeDescriptionKey)?_c('Banner',{staticClass:"type-banner mb-20 mt-0",attrs:{"color":"info","closable":true,"label-key":_vm.typeDescriptionKey},on:{"close":_vm.hideTypeDescription}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }